import styled from 'styled-components'
import { theme } from '../../../style/theme'
import { OrderInfo, OrderInfoBlock, OrderInfoItem } from '../processingTimeOrder/index.styled'
import { colorTheme } from '../../../style/theme/colorTheme'

export const PreOrderModalWrapper = styled.div`
	font-size: 1rem;
	display: grid;

	@media screen and (max-width: ${theme.point820}) {
		margin-bottom: 2.85em;
	}

	@media screen and (max-width: ${theme.point720}) {
		gap: 1em;
		grid-template-columns: auto;
		margin-bottom: 4.68em;
	}
`
PreOrderModalWrapper.displayName = 'PreOrderModalWrapper'

export const PreOrderIconWrap = styled.div`
	border-radius: 0.75em;
	border: 1px solid ${colorTheme.confirmPreOrderModal.border};
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1em;
	min-height: 5.6em;

	svg {
		width: 5.17em;
		height: 5.8em;
	}
`
PreOrderIconWrap.displayName = 'PreOrderIconWrap'

export const ModalInfo = styled(OrderInfo)`
	gap: 0.63em;
	margin-bottom: 0;
`
ModalInfo.displayName = 'ModalInfo'

export const ModalInfoBlock = styled(OrderInfoBlock)`
	min-height: 5.63em;

	&.column {
		flex-direction: column;
		gap: 0.43em;
	}

	@media screen and (max-width: ${theme.point720}) {
		min-height: 7.5em;

		&.small {
			min-height: 6.87em;
		}
	}
`
ModalInfoBlock.displayName = 'ModalInfoBlock'

export const ModalInfoItem = styled(OrderInfoItem)`
`
ModalInfoItem.displayName = 'ModalInfoItem'

export const OrderWrap = styled.div`
	height: 24.68em;
	min-width: 60em;
	display: flex;
	flex-direction: column;
	border: 1px solid ${colorTheme.confirmPreOrderModal.borderOrder};
	padding: 0.87em 0.63em;
	border-radius: 0.75em;

	@media screen and (max-width: ${theme.point820}) {
		height: auto;
		min-width: initial;
	}

	@media screen and (max-width: ${theme.point720}) {
		border: none;
		padding: 0;
		margin-top: 1.25em;
	}
`
OrderWrap.displayName = 'OrderWrap'
